import React from 'react';
import PropTypes from 'prop-types';
import { Elements } from 'react-stripe-elements';

import AddCardModal from './AddCardModal';
import { ValidationStatusModal } from './../UIComponents';

export default class PaymentMethod extends React.Component {
  constructor() {
    super();

    this.state = {
      isAddCardVisible: false,
      isAddCardComplete: false,
    };

    this.onChangeCard = this.onChangeCard.bind(this);
    this.onChangeCardClose = this.onChangeCardClose.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const newState = {};

    if (
      nextProps.billing.isCardAdded !== this.props.billing.isCardAdded
      && typeof nextProps.billing.isCardAdded === 'boolean'
    ) {
      newState.isAddCardComplete = true;
      newState.isAddCardVisible = false;

      // Fetch default card after successful save
      this.props.getDefaultCard();

      setTimeout(this.onChangeCardClose, 5000);
    }

    this.setState(newState);
  }

  onChangeCard() {
    this.setState({
      isAddCardVisible: true,
      isAddCardComplete: false,
    });
  }

  onChangeCardClose() {
    this.setState({
      isAddCardVisible: false,
      isAddCardComplete: false,
    });
  }

  render() {
    const { defaultCard } = this.props.billing;
    const planInfo = this.props.billing.client;

    const commonElements = [(
      <Elements>
        <AddCardModal
          visibility={this.state.isAddCardVisible}
          onClose={this.onChangeCardClose}
          addCard={this.props.addCard}
          isEdit={defaultCard && !!defaultCard.last4}
        />
      </Elements>
    ), (
      <ValidationStatusModal
        visibility={this.state.isAddCardComplete}
        status={this.props.billing.isCardAdded}
        onClose={this.onChangeCardClose}
        successMessage="Added Successfully"
        errorMessage={this.props.billing.addCardError.message}
      />
    )];

    if (defaultCard && defaultCard.last4) {
      return (
        <div className="payment-method">
          <div className="payment-method__header">
            <h5>PAYMENT METHOD</h5>
          </div>
          <div className="payment-method__content">
            <div className="payment">
              <p className="payment__status">
                {planInfo.billing_information}
              </p>
              <div className="payment__card credit-card">
                <p className="credit-card__name">{defaultCard.card_holder}</p>
                <p className="credit-card__number">**** **** **** {defaultCard.last4}</p>
              </div>
            </div>
          </div>
          <div className="payment-method__actions">
            <button type="button" className="btn btn--link" onClick={this.onChangeCard}>
              Change Card
            </button>
          </div>
          {commonElements}
        </div>
      );
    }

    return (
      <div className="payment-method">
        <div className="payment-method__header">
          <h5>PAYMENT METHOD</h5>
        </div>
        <div className="payment-method__content">
          <p className="no-content">You dont have any cards yet</p>
        </div>
        <div className="payment-method__actions">
          <button type="button" className="btn btn--link" onClick={this.onChangeCard}>
            Add new card
          </button>
        </div>
        {commonElements}
      </div>
    );
  }
}

PaymentMethod.defaultProps = {
  getDefaultCard: () => {},
  addCard: () => {},
};

PaymentMethod.propTypes = {
  getDefaultCard: PropTypes.func,
  addCard: PropTypes.func,
  billing: PropTypes.shape({
    isCardAdded: PropTypes.bool,
    addCardError: PropTypes.shape({
      message: PropTypes.string,
    }),
    defaultCard: PropTypes.shape({
      card_holder: PropTypes.string,
      last4: PropTypes.string,
    }),
    client: PropTypes.shape({
      billing_information: PropTypes.string,
    }),
  }).isRequired,
};
